var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoWyloguj(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40,22.5c0,9.67-7.84,17.5-17.5,17.5-9.66,0-17.5-7.84-17.5-17.5,0-9.67,7.84-17.5,17.5-17.5,9.66,0,17.5,7.84,17.5,17.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.8,23.07c0,4.58-3.72,8.3-8.3,8.3s-8.3-3.72-8.3-8.3c0-2.77,1.39-5.35,3.71-6.9.46-.31,1.08-.18,1.39.28.31.46.18,1.08-.28,1.39-1.76,1.17-2.82,3.13-2.82,5.23,0,3.47,2.83,6.3,6.3,6.3s6.3-2.83,6.3-6.3c0-2.1-1.05-4.06-2.82-5.24-.46-.31-.58-.93-.28-1.39.31-.46.93-.58,1.39-.28,2.32,1.55,3.71,4.13,3.71,6.9Zm-8.3-2.36c.55,0,1-.45,1-1v-7.09c0-.55-.45-1-1-1s-1,.45-1,1v7.09c0,.55.45,1,1,1Z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWyloguj);
export default __webpack_public_path__ + "static/media/ico-wyloguj.a44320a25d64ada131f03fe2031009db.svg";
export { ForwardRef as ReactComponent };